const common = {
    action: "aksi",
    active: "aktif",
    active_non: "tidak aktif",
    add: "tambah",
    address: "alamat",
    approve: "approve",
    attribute: 'atribut',
    back: "kembali",
    bank: "bank",
    batch: "label",
    // brand: "merek",
    brand: "principal",
    category: "kategori",
    cancel: "batal",
    chose: "pilih",
    chose_img: "pilih gambar",
    closing: "penutupan",
    code: 'kode',
    courier: "kurir",
    company: "perusahaan",
    credit: "hutang",
    customer: "pelanggan",
    customer_type: "jenis pelanggan",
    date: "tanggal",
    date_due: "tanggal jatuh tempo",
    date_start: "tanggal mulai",
    date_end: "tanggal akhir",
    date_range: "rentang tanggal",
    date_update: "tanggal diperbarui",
    debit: "piutang",
    delete: "hapus",
    detail: 'detail',
    description: "deskripsi",
    discount: "potongan",
    difference: "selisih",
    document_type: 'jenis dokumen',
    duplicate: 'duplikat',
    edit: "ubah",
    email: "E-mail",
    export_excel: "ekspor ke excel",
    export_csv: "ekspor ke CSV",
    export_pdf: "ekspor ke PDF",
    finish: "selesai",
    fullname: "nama lengkap",
    goods: "barang",
    height: "tinggi",
    history: "riwayat",
    image: "gambar",
    info: "keterangan",
    language: "bahasa",
    loading: "menunggu...",
    location: "lokasi",
    length: "panjang",
    method: "metode",
    name: "nama",
    name_full: "nama lengkap",
    next_month: "bulan depan",
    no: "Nomor",
    no_recap: "Nomor Rekap",
    no_invoice: "Nomor Tagihan",
    note: "catatan",
    no_option: "tidak ada pilihan",
    no_description: "tidak ada deskripsi",
    pass: "kata sandi",
    pass_conf: "konfirmasi kata sandi",
    pass_new: "kata sandi baru",
    pass_reset: "atur ulang kata sandi",
    pass_change: "ubah kata sandi",
    persentage: "persentase",
    phone: "no. telp",
    prev_month: "bulan sebelumnya",
    price: "harga",
    price_buy: "harga beli",
    price_sell: "harga jual",
    price_retail: "harga retail",
    print: "cetak",
    process: "proses",
    progress: "progres",
    profile: "profil",
    product: "produk",
    quantity: "kuantitas",
    quantity_sell: "kuantitas terjual",
    reference: "referensi",
    reject: "tolak",
    request: "permintaan",
    sales: "sales",
    save: "simpan data",
    search: "cari",
    serial_num: "nomor seri",
    sku: "SKU",
    supplier: "pemasok",
    supplier_type: "jenis pemasok",
    status: "status",
    stock: "stok",
    storage: "penyimpanan",
    telp: "telp",
    type: "tipe",
    unit: "satuan",
    upload: "unggah",
    user: "pengguna",
    warehouse: "gudang",
    weight: "berat",
    width: "lebar",
    verification: "verifikasi",
}

export default common